import type { ReactNode } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Sheet, SheetContent } from "@/components/ui/sheet";
export function CreationOverlay({
  open,
  onOpenChange,
  children,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
}) {
  const mobile = useIsMobile();
  return mobile ? (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        className="h-dvh min-h-0 gap-0 p-0 flex flex-col overflow-hidden"
        onClick={(event) => event.stopPropagation()}
        aria-describedby={undefined}
      >
        {children}
      </SheetContent>
    </Sheet>
  ) : (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-4xl max-h-[90dvh] min-h-0 gap-0 p-0 flex flex-col overflow-hidden"
        onClick={(event) => event.stopPropagation()}
        aria-describedby={undefined}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}
